/**
 * Ping server to sustain authenticated session.
 */
import IService from '../IService';

export default IService.extend({
  /**
   * Resolved if user is authenticated
   * @return {deferred.promise}
   */
  get: function () {
    const deferred = new $.Deferred();
    $.ajax({
      url: app.apiUrl('/api/v1/users/me/minimized'),
      error: function (jqXHR) {
        deferred.reject(jqXHR);
      },
      /**
       * Response values:
       * true :== session is known by the server, user authenticated
       * false :== user lost authentication, was logged out
       * null :== exception
       */
      success: function (response) {
        if (_.isObject(response)) {
          deferred.resolve(response);
        } else {
          deferred.reject(response);
        }
      },
    });

    return deferred.promise();
  },
});
